import { PlayerSwap } from "@/api/privateRequests/sbcs/player-swap";
import pitch from "@/assets/pitch.png";
import { pitchCardPlaceholder } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { Sbc } from "@/redux/sbcs/sbcsSlice";
import clsx from "clsx";
import React, { RefObject } from "react";

import { PlayerCardHolder } from "./PlayerCardHolder";

type PitchViewProps = {
  // solutionStatus: string;
  // overlayLeft: string;
  pitchRef: RefObject<HTMLDivElement>;
  sbc: Sbc;
  sbcFormation?: string;
  playersToRender: any[];
  isMobile: boolean;
  isTouch: boolean;
  smallDesktop: boolean;
  widthClass: string;
  selectedPlayer?: number;
  selectedPlayerSwap?: number;
  playerSwaps: PlayerSwap[][];
  loadingSwaps: boolean;
  handlePlayerClicked: (i: number) => void;
  handleSwapClicked: (i: number) => void;
  onSwapClicked: (p: PlayerSwap, index: number) => void;
  // SBCStatusOverlay: React.FC<{ left: string }>;
};

export const PitchView: React.FC<PitchViewProps> = ({
  // solutionStatus,
  // overlayLeft,
  pitchRef,
  sbcFormation,
  playersToRender,
  isMobile,
  isTouch,
  smallDesktop,
  widthClass,
  selectedPlayer,
  selectedPlayerSwap,
  playerSwaps,
  loadingSwaps,
  handlePlayerClicked,
  handleSwapClicked,
  onSwapClicked,
  // SBCStatusOverlay,
  sbc,
}) => {
  return (
    <div
      className={cn(
        "relative w-9/12 aspect-[120/100]",
        isMobile && "w-full h-screen aspect-auto",
      )}
    >
      {/* {solutionStatus === "pending" && <SBCStatusOverlay left={overlayLeft} />} */}

      <div
        className="absolute inset-0 z-0 bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${pitch})` }}
        aria-hidden
      />

      <div
        ref={pitchRef}
        className={cn(
          "absolute inset-0 min-h-[calc(100%+80px)]",
          `ut-squad-pitch-view ${sbcFormation}`,
        )}
        style={{
          ["--slot-offset-y" as any]: "-90%",
        }}
      >
        {playersToRender.map((player, index: number) => {
          const k =
            Number.isNaN(parseInt(player?.id)) || player?.placeholder
              ? `ph-${index}`
              : player?.id;

          if (!sbc) return null;
          return (
            <div key={k}>
              {player.placeholder ? (
                <div
                  className={clsx(
                    `absolute ut-squad-slot-view-${index} -translate-x-1/2 z-20 animate-pulse`,
                    isMobile
                      ? "min-h-[calc(15%)]"
                      : isTouch
                        ? "min-h-[calc(20%)]"
                        : smallDesktop
                          ? "min-h-[calc(15%)]"
                          : "min-h-[calc(20%)]",
                    widthClass,
                    "aspect-[111/154] shrink-0 ",
                  )}
                >
                  {pitchCardPlaceholder}
                </div>
              ) : (
                <PlayerCardHolder
                  player={player}
                  index={index}
                  handlePlayerClicked={handlePlayerClicked}
                  handleSwapClicked={handleSwapClicked}
                  onSwap={(p) => onSwapClicked(p, index)}
                  showSwapView={index === Number(selectedPlayerSwap)}
                  showPlayerInfo={index === Number(selectedPlayer)}
                  playerSwaps={playerSwaps[index]}
                  loadingSwaps={loadingSwaps}
                  selected={selectedPlayer === index}
                  pitchHeight={pitchRef.current?.clientHeight}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
